




























import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-add-to-cart-modal',
  components: ServiceContainer().getComponents(),
})

export default class extends Vue {
  @Prop({required: true}) product: object;
  private products: Array<object> = [];

  private get productImage(): string {
    const imageGallery = this.product.hasOwnProperty('image_gallery') ? JSON.parse(this.product['image_gallery']) : {};
    return (Object.keys(imageGallery).length && imageGallery.hasOwnProperty('400')) ? imageGallery['400'][0] : '';
  }

  private get showModal(): boolean {
    return this.$store.state['CheckoutTotals']['showCartModal'];
  }
  private closeModal(): void {
    this.$store.dispatch('CheckoutTotals/showAddToCartModal');
  }
}
